module.exports = __webpack_public_path__ + "img/cabins-map-mobile--en.baeea229.png";